import styled from 'styled-components';
import colors from 'constants/colors';

export const VerificationInputFieldContainer = styled.div`
  position: relative;
  width: ${(props) => (props.width?? '100%')};
  margin: ${(props) => props.margin?? '0 0 20px 0'};
  color: ${colors.white};

  .icon {
    position: absolute;
    left: 200px;
    top: 45px;
    width: 20px;
    height: 20px;
    z-index: 100;
  }

  .blockContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    input {
      width: ${(props) => (props.inputWidth?? '40px')};
      height: ${(props) => (props.inputHeight?? '40px')};
      font-size: ${(props) => (props.inputFontSize?? '14px')};
      font-weight: ${(props) => (props.inputFontWeight?? '600')};
      box-sizing: border-box;
      border: 1px solid
        ${(props) => props.error? colors.red: props.borderColor?? colors.darkGrey};
      color: ${(props) => props.inputColor?? colors.white};
      text-align: center;
      background-color: ${(props) => props.inputBackgroundColor?? colors.black2};

      :focus-visible {
        outline: none;
        background-color: ${colors.black1};
      }
    }
  }

  label {
    width: 100%;
    display: block;
    font-size: ${(props) => (props.labelSize?? '12px')};
    font-weight: ${(props) => (props.labelWeight?? '300')};
    color: ${(props) => props.labelColor?? colors.white};
    margin-bottom: 5px;
    letter-spacing: 1px;
    text-align: ${(props) => props.labelPosition === 'center'? 'center': 'left'};

    span {
      font-size: 18px;
      color: ${colors.red};
    }
  }

  .warning {
    width: 100%;
    line-height: 20px;
    color: ${colors.red};
    font-size: 14px;
    font-weight: 600;
    font-style: italic;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    text-align: left;
    margin-top: 5px;
  }
`;
